import { render, staticRenderFns } from "./DkLoader.vue?vue&type=template&id=4d163289&scoped=true&"
import script from "./DkLoader.vue?vue&type=script&lang=js&"
export * from "./DkLoader.vue?vue&type=script&lang=js&"
import style0 from "./DkLoader.vue?vue&type=style&index=0&id=4d163289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d163289",
  null
  
)

export default component.exports